import { motion, useReducedMotion } from "motion/react";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Vertical offset in px before reveal. Default 12. */
  y?: number;
  /** Delay in seconds. */
  delay?: number;
  /** Duration in seconds. Default 0.6. */
  duration?: number;
  /** Viewport amount (0–1) before triggering. Default 0.2. */
  amount?: number;
  className?: string;
  as?: "div" | "section" | "span" | "li";
}

const RevealOnScroll = ({
  children,
  y = 12,
  delay = 0,
  duration = 0.6,
  amount = 0.2,
  className,
  as = "div",
}: Props) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as];

  if (reduce) {
    const Tag = as;
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export default RevealOnScroll;
